<template>
    <div class="col-lg-12 col-md-10 col-sm-9 content container-fluid">
            <div class="wrapper">
                <div class="container-wrapper">
                    <div id="alerts-container">
                    </div>
                </div>
            </div>
            <!--OFFERS-->
            <div class="row m-t-25">
                <div class="col-lg-12 m-b-20">
                    <div class="col-xs-12 col-lg-6 m-t-10">
                        <h4 class="text-master text-light">
                                Realiza tus pagos a tiempo, sin cargos adicionales por mora, a través de nuestra alianza estratégica con:
                        </h4>
                    </div>

                    <div class="col-xs-12 col-lg-6 text-center">
                        <img src="/images/pagatodo-logo.png" width="300px">
                    </div>

                    <div class="clearfix"></div>
                </div>
                <div class="col-lg-12">
                    <div class="panel-group" id="accordion-test" role="tablist" aria-multiselectable="true">
                        <!--Telecomunicaciones-->
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion-test" href="#telecomunicaciones" aria-expanded="false" class="collapsed f-text-md">
                                            Generales <i class="fa fa-angle-down pull-right"></i>
                                        </a>
                                    </h4>
                            </div>
                            <div id="telecomunicaciones" class="panel-collapse collapse">
                                <div class="panel-body">
                                    <div>
                                        <div class="col-xs-12">
                                            <div class="offers-slide">


                                            </div>

                                        </div>
                                        <div class="clearfix"></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--/Telecomunicaciones-->
                    </div>
                </div>
                <!-- modal view offer -->
                <div class="modal fade" id="view-offer">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="col-xs-12 col-lg-6">
                                    <div class="modal-offer-img" style="background: url(&quot;http://apidev.cashdepotint.com&quot;) center center / cover no-repeat;"></div>
                                </div>
                                <div class="col-xs-12 col-lg-6">
                                    <h3></h3>
                                    <p></p>
                                    <ul class="dots-leader">
                                        <li><span>Descuento</span> <span class="text-20 text-bold"> %</span></li>
                                        <li class="m-t-10"><span></span>
                                            <span class="text-20 text-bold"> Cuotas</span>
                                            </li>
                                    </ul>
                                    <div class="clearfix"></div>
                                    <hr>
                                    <h4>
                                    <span class="m-l-10 sm-ico">(<a target="_blank"></a>)</span>
                                </h4>
                                    <p class="m-t-15"><i class="md  md-location-on sm-ico"></i></p>
                                    <p class="m-t-15"><i class="md  md-phone sm-ico"></i></p>
                                    <div class="text-center m-t-35 m-b-15">
                                        <button class="btn btn-success">SOLICITAR <i class="b-l b-white p-l-10 m-l-10 md  md-local-offer sm-ico"></i></button>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
                <!--/OFFERS-->
                <!-- modal-content -->
                <div class="modal fade" id="_confirmLogoutModal">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 class="modal-title">Logout</h4>
                            </div>
                            <div class="modal-body">
                                Esta seguro que desea salir del sistema?
                            </div>
                            <div class="modal-footer">
                                <div class="row">
                                    <div class="col-md-12 pull-right">
                                        <a data-dismiss="modal" class="btn btn-default">VOLVER</a>
                                        <a class="btn btn-primary" id="_submitLogout">LOGOUT</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: 'client-offers-all',
        props: {
            /**
             * Específica el tipo de contexto de la nota a crear (cobrar/pagar)
             */
            operation: {
                type: String,
                required: true
            },
            offer: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                amount: 0,
                cost: 0,
                categories: [],
                comission_percent: 0,
                description: '',
                discount_percent: 0,
                due_date: '',
                days: 0,
                fee: 0,
                imagen: null,
                imageSrc: '',
                internOffer: '',
                providers: [],
                selectedCategory: '',
                selectedProvider: '',
                selectedServiceType: '',
                selectedType: 0,
                serviceType: [],
                startDate: '',
                title: '',
                type: [],
                validity: 0,
            }
        },
        watch: {
            'selectedServiceType': function() {
                if(this.selectedServiceType && this.serviceType.length) {
                    this.setCategories();
                }
            },
            'serviceType': function() {
                if(this.selectedServiceType && this.operation == "edit" && this.serviceType.length) {
                    this.setCategories();
                }
            },
            'offer': function() {
                if(this.offer) {
                    this.getOffer();
                }
            }
        },
        created() {
            //this.getStatus();
            this.getProviders();
            this.getOfferType();
            this.getOfferServiceType();
        },
        methods: {
            createOffer: function() {
                let data = new FormData();

                data.append('title', this.title);
                data.append('description', this.description);
                data.append('start_date', moment(this.startDate).format("YYYY-MM-DD"));
                data.append('due_date', moment(this.due_date).format("YYYY-MM-DD"));
                data.append('validity', this.validity);
                data.append('comission_percent', this.comission_percent);
                data.append('discount_percent', this.discount_percent);
                data.append('status_id', 1);
                data.append('fee', this.fee);
                data.append('days_id', this.days);
                data.append('categories_id', this.selectedCategory);
                data.append('type_id', this.selectedType);
                data.append('service_type_id', this.selectedServiceType);
                data.append('provider_id', this.selectedProvider);
                data.append('intern', 1);
                data.append('image', this.imagen);
                data.append('amount', this.amount);
                data.append('cost', this.cost);

                this.$http({
                    emulateJSON: true,
                    emulateHTTP: true,
                    url: apiUrl + '/offers',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: data,
                }).then(function(response) {
                    swal("¡Listo!", "¡Oferta creada exitosamente!", "success");
                    $('#new-offer').modal('toggle');
                    this.cleanFields();
                }, response => {
                    sweetAlert("Oops...", "¡Ha ocurrido un error al crear la oferta! " + response.status.message, "error");
                });

                //get new data
                this.$broadcast('vuetable:reload');
            },
            cleanFields() {
                        this.title = "";
                        this.description = "";
                        this.startDate = "";
                        this.comission_percent = "";
                        this.discount_percent = "";
                        this.selectedCategory = "";
                        this.selectedType = 0;
                        this.selectedServiceType = 0;
                        this.selectedProvider = 0;
                        this.amount = "";
                        this.cost = "";
                        this.days = "";
                        this.fee = "";
                        this.validity = "";
                        this.due_date = "";
            },
            getOffer() {
                this.amount = this.offer.amount;
                this.cost = this.offer.cost;
                this.categories = this.offer.categories;
                this.comission_percent = this.offer.comission_percent;
                this.description = this.offer.description;
                this.discount_percent = this.offer.discount_percent;
                if (this.offer.validity) {
                    this.due_date = this.offer.due_date;
                }
                this.days = this.offer.days_id;
                this.fee = this.offer.fee;
                this.imagen = this.offer.imagen;
                this.internOffer = this.offer.intern;
                this.selectedProvider = this.offer.provider_id;
                this.selectedServiceType = this.offer.service_type_id;
                this.selectedType = this.offer.type_id;
                this.selectedCategory = this.offer.categories_id;
                this.startDate = this.offer.start_date;
                this.title = this.offer.title;
                this.validity = this.offer.validity;
            },
            getOfferType: function() {
                this.$http.get(apiUrl + '/offer-types').then(response => {
                    this.type = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
                });
            },
            getOfferServiceType: function() {
                this.$http.get(apiUrl + '/service-types?relationships=categories').then(response => {
                    this.serviceType = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
                });
            },
            getProviders: function() {
                this.$http.get(apiUrl + '/providers').then(response => {
                    this.providers = response.data;
                }, response => {
                    sweetAlert("Oops...", "Ha ocurrido un error al cargar los proovedores !", "error");
                });
            },
            setCategories() {
                let service = this.serviceType.find(service => {
                    return service.id == this.selectedServiceType;
                });
                this.categories = service.categories;
            },
            sync: function(event, tipo) {
                event.preventDefault();
                this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

                var image = new Image();
                var reader = new FileReader();
                var vm = this;
                reader.onload = (event) => {
                    vm.imageSrc = event.target.result;
                };

                reader.readAsDataURL(this[tipo]);
            },
            updateOffer: function() {
                let data = {};

                data.title = this.title;
                data.description = this.description;
                data.start_date = moment(this.startDate).format("YYYY-MM-DD");
                data.due_date = moment(this.due_date).format("YYYY-MM-DD");
                data.validity = this.validity;
                data.comission_percent = this.comission_percent;
                data.discount_percent = this.discount_percent;
                data.status_id = 1;
                data.fee = this.fee;
                data.days_id = this.days;
                data.categories_id = this.selectedCategory;
                data.type_id = this.selectedType;
                data.service_type_id = this.selectedServiceType;
                data.provider_id = this.selectedProvider;
                data.intern = 1;
                data.image = this.imageSrc;
                data.amount = this.amount;
                data.cost = this.cost;

                $.ajax({
                    url: apiUrl + `/offers/${this.offer.id}`,
                    type: 'PUT',
                    data: data,
                    contentType: 'application/x-www-form-urlencoded',
                    success: (data) => {
                        swal("¡Listo!", "¡Oferta actualizada exitosamente!", "success");
                        $('#new-offer').modal('toggle');
                        this.$dispatch("updated-offer");
                    },
                    error: function(data) {
                        sweetAlert("Oops...", "¡Ha ocurrido un error al actualizar la oferta! " + response.status.message, "error");
                    }
                });
            },
            verifyRequiredFields() {
                let fields = this.title
                && this.description
                && this.startDate
                && this.comission_percent
                && this.discount_percent
                && this.selectedCategory
                && this.selectedType
                && this.selectedServiceType
                && this.selectedProvider
                && this.amount
                && this.cost;

                let requiredPaymentLoans = false;

                if (this.selectedType == "1" && !this.days) {
                    requiredPaymentLoans = true;

                } else if (this.selectedType == "2" && !this.fee) {
                    requiredPaymentLoans = true;
                }

                let requiredDueDate = Number(this.validity) && !this.due_date;

                if (fields && !requiredPaymentLoans && !requiredDueDate) {
                    if(this.operation == "edit") {
                        this.updateOffer();
                    } else {
                        this.createOffer();
                    }
                } else {
                    sweetAlert("Oops...", "¡Llene todos los campos requeridos!", "error");
                }
            }
        },
        computed: {
            deleteData: function() {
                if (this.selectedType == '1') {
                    return this.days = ''
                } else {
                    return this.fee = ''
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// client-offers-all.vue?5a4fcefd